import { useState } from "react";
import { toast } from "../../utils/toast";
import { abroadAdminApi } from "../../api/abroadLoans";
import { errorMessageOf } from "../../api/scholarships";
import CreateDraftDialog from "../calls/CreateDraftDialog";
import { useDraftForm } from "../calls/forms";
import { EMPTY_DETAILS, detailErrorsOf, detailsOf, useCallSaved, validateDetails } from "./model";
import CallDetailsFields from "./CallDetailsFields";

/**
 * Creates a draft loan call, then hands it to `onCreated` so its set-up can continue. Closing the
 * dialog keeps the draft form; Cancel or a successful create clears it.
 */
export default function CreateCallDialog({ open, onClose, onCreated }) {
  const saved = useCallSaved();
  const { form, errors, setErrors, update, reset } = useDraftForm("abroad-call-new", EMPTY_DETAILS);
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    setErrors({});
    onClose();
  };

  const submit = async (e) => {
    e.preventDefault();
    const found = validateDetails(form);
    setErrors(found);
    if (Object.keys(found).length) return;

    setSubmitting(true);
    try {
      const { data } = await abroadAdminApi.createCall("LOAN", detailsOf(form));
      saved(data);
      toast.success("Draft loan call created. Continue its set-up.");
      reset();
      onCreated(data);
    } catch (error) {
      console.error("Failed to create the loan call:", error);
      setErrors(detailErrorsOf(error));
      toast.error(errorMessageOf(error, "Failed to create the loan call. Please try again."));
    } finally {
      setSubmitting(false);
    }
  };

  const field = (name) => ({ name, value: form[name], onChange: update, error: errors[name], disabled: submitting });

  return (
    <CreateDraftDialog
      open={open}
      title="New loan call"
      formId="create-abroad-call"
      submitting={submitting}
      onClose={close}
      onCancel={() => {
        reset();
        onClose();
      }}
      onSubmit={submit}
    >
      <CallDetailsFields field={field} values={form} />
    </CreateDraftDialog>
  );
}
